import { relayStylePagination } from '@apollo/client/utilities'

export const typePolicies = {
  Query: {
    fields: {
      loadingEvents: relayStylePagination(['id', 'text', 'currentState']),
      companyRelations: relayStylePagination(['id', 'text', 'enables', 'involvements']),
      contracts: relayStylePagination(['id', 'text', 'enables']),
      employees: relayStylePagination([
        'id',
        'disables',
        'enables',
        'orderBy',
        'first',
        'hasManyOrderBy',
        'hasOneOrderBy',
        'freightageRoles',
        'systemSettingRoles'
      ]),
      trucks: relayStylePagination([
        'id',
        'disables',
        'enables',
        'orderBy',
        'first',
        'hasManyOrderBy',
        'hasOneOrderBy'
      ]),
      units: relayStylePagination(['id', 'dates', 'date'])
    }
  }
}
